/**
 * Created by RKL on 13/08/2015.
 */
define('smpResDetailView',[
  'module',
  'smpResCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!smpResDetailTabTpl'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl
) {
  'use strict';

  var SmpResDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.viewLess = this.model.get('secId');
      return templateData;
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        smpresModel: this.model
      });
      createEditView.show({
        title: _.i18n('smpres.edit')
      });
    }

  });

  module.exports = SmpResDetailView;
});
